import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyC--ubl2bVzPM696fJTfRUF6ueMJ8Rqx1Q",
  authDomain: "miyazaki-quiz-culture.firebaseapp.com",
  projectId: "miyazaki-quiz-culture",
  storageBucket: "miyazaki-quiz-culture.firebasestorage.app",
  messagingSenderId: "916077246069",
  appId: "1:916077246069:web:d5ffa61d2693ce02592a3c"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
